import React from 'react'
import "./Nazm.scss";

function Nazm() {
  return (
    <div className="Nazm">
     <h1>
     Nazm
     </h1>
    </div>
  )
}

export default Nazm
